'use strict';
import { newModalFromString } from 'components/modal';
import { handleColorVariationClick } from './product/base';

function initPdpSlickCarousel () {
    const $mainCarousel = $('.js-pdpCarousel .pdpCarousel__slider');
    const $swatchCarousel = $('.pdpCarousel__slider-nav');

    if ($mainCarousel.length === 0) return;
    if ($mainCarousel.hasClass('slick-initialized')) return;

    const $container = $mainCarousel.closest('.product-detail');
    const $prev = $container.find('.custom-prev');
    const $next = $container.find('.custom-next');

    $mainCarousel.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $prev,
        nextArrow: $next,
        asNavFor: '.pdpCarousel__slider-nav',
        adaptiveHeight: true,
        infinite: true,
        lazyLoad: 'ondemand',
        centerMode: true,
        centerPadding: '4px'
    });

    $swatchCarousel.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.js-pdpCarousel .pdpCarousel__slider',
        focusOnSelect: true,
        arrows: true,
        prevArrow: $prev,
        nextArrow: $next,
        infinite: true,
        centerMode: true,
        centerPadding: '4px'
    });

    $mainCarousel.on('setPosition', function () {
        $(this).find('.slick-slide').addClass('margin-slick-slide');
        $(this).find('.slick-track, .slick-list.draggable').addClass('height-slick-list');
    });
}

function initColorSlickCarousel () {
    $('.slider-values-container').each(function () {
        const $carousel = $(this);

        if ($carousel.hasClass('slick-initialized')) {
            return;
        }

        const $container = $carousel.closest('.product-detail');
        const $prev = $container.find('.color-prev');
        const $next = $container.find('.color-next');
        const slideCount = $carousel.children('a.color-variation').length;
        const maxSlide = 6;
        const slidesToDisplay = Math.min(slideCount, maxSlide);

        $carousel.on('init afterChange', function (currentSlide) {
            if (slideCount > maxSlide) {
                $prev.removeClass('slick-hidden');
                $next.removeClass('slick-hidden');
            } else {
                $prev.addClass('slick-hidden');
                $next.addClass('slick-hidden');
            }
        });

        if ($carousel.closest('.js-cart-edit-product-modal').length) {
            $('.carousel-header__button-wrapper').removeClass('show-for-small-only');
        }

        $carousel.slick({
            slidesToShow: slidesToDisplay,
            slidesToScroll: slidesToDisplay,
            arrows: true,
            infinite: false,
            prevArrow: $prev,
            nextArrow: $next
        });
    });
}

function _modalOpenerHelperAjax (url, hasImagesSlider) {
    if (!url) {
        return;
    }

    $.spinner().start();
    $.ajax(url).then(data => {
        $.spinner().stop();
        const modalBigContent = newModalFromString(data, false, ['cc-quickAddToCart-modal'], handleSizebayInjection);
        modalBigContent.open();

        if (hasImagesSlider) {
            initImagesSlickCarousel();
        } else {
            $(modalBigContent.modal).find('.js-color-selection').addClass('hide');
            $(modalBigContent.modal).find('.js-selected-color-info').addClass('hide');
        }

        $(modalBigContent.modal).find('.js-quantity-selector').removeClass('hidden');

        // Uncheck size radios so no size starts pre-selected
        $(modalBigContent.modalBox).find('.sizes-container input[type="radio"]').prop('checked', false);

        $(modalBigContent.modalBox).on('click', '.js-quickAdd-footer_confirm', function (e) {
            modalBigContent.close();
        });

        $(modalBigContent.modalBox).find('.js-close').on('click', function (e) {
            modalBigContent.close();
        });

        $('[data-dismiss="modalBigContent"]').on('click', function (e) {
            e.preventDefault();
            modalBigContent.close();
        });

        $('.js-completeThePromo-modal-selectedColor').text($('.js-completeThePromo-modal-color-swatch.selected + .js-completeThePromo-modal-color-value').text());

        $(modalBigContent.modalBox).on('change', '.sizes-container input[type="radio"]', function (e) {
            $(modalBigContent.modalBox).find('.js-quickAdd-footer_confirm').removeClass('disabled');
        });

        $(modalBigContent.modalBox).on('click', '.color-variation', (e) => {
            handleColorVariationClick(e, modalBigContent.modalBox);
        });

        initPdpSlickCarousel();

        const pid = $(modalBigContent.modalBox).find('.js-product-quickview--tezenis').data('pid');
        $('body').trigger('product:triggerProductDetails', pid);
    }).fail(() => {
        $.spinner().stop();
    });
}

function modalQuickAdd () {
    $('body').on('click', '.js-quick-add', function (e) {
        e.preventDefault();
        let url = $(e.currentTarget).data('url');
        const hasImagesSlider = $(this).data('has-slider');
        _modalOpenerHelperAjax(url, hasImagesSlider);
    });
}

/**
 * This event will load sizebay for a product, every time a drawer containing recommendation products on PDP is opened (drawer is present only on mobile devices).
 */
function handleSizebayInjection () {
    document.dispatchEvent(
        new CustomEvent('sizebay:pdp_recommendation_drawer_opened', {
            detail: {
                // Two templates exist, which contain 'data-sizebay-id'. Using one class is too ambiguous due to the existing logic.
                productId: $('.js-mobile-completePromo, .js-product-quickview--tezenis').data('sizebay-id')
            }
        })
    );
}

function initImagesSlickCarousel() {
    $('.carousel-inner').slick({
        dots: false,
        arrows: true,
        slidesToShow: 3.4,
        prevArrow: '<button class="slick-prev custom-prev prev-button" aria-label="Prev" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none"><path d="M8.05469 0.523438L0.742189 7.83594L8.05469 15.1484" stroke="#1C1C1C" stroke-width="1.05" stroke-linecap="round"/></svg></button>',
        nextArrow: '<button class="slick-next custom-next next-button" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none"><path d="M0.523438 15.1484L7.83594 7.83594L0.523437 0.523439" stroke="#1C1C1C" stroke-width="1.05" stroke-linecap="round"/></svg></button>',
        draggable: true,
        infinite: false,
        slidesToScroll: 3.4,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    draggable: true,
                    slidesToShow: 2.85,
                    slidesToScroll: 2.85,
                }
            }
        ]
    });

    $('.cc-completeThePromo-modal-color-wrapper').each(function () {
        const $carousel = $(this);
        if ($carousel.hasClass('slick-initialized')) {
            return;
        }

        const $container = $carousel.closest('.product-detail');
        const $prev = $container.find('.color-prev');
        const $next = $container.find('.color-next');
        const slideCount = $carousel.children('a.color-variation').length;
        const maxSlide = 5;
        const slidesToDisplay = Math.min(slideCount, maxSlide);

        $carousel.on('init', function () {
            $prev.toggleClass('slick-hidden', !(slideCount > maxSlide));
            $next.toggleClass('slick-hidden', !(slideCount > maxSlide));

            if (slideCount > maxSlide) {
                $('.carousel-header__button-wrapper').removeClass('hide');
            }
        });

        $carousel.slick({
            variableWidth: true,
            slidesToShow: slidesToDisplay,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            prevArrow: $prev,
            nextArrow: $next
        });
    });
}

module.exports = {
    initColorSlickCarousel: initColorSlickCarousel,
    initPdpSlickCarousel: initPdpSlickCarousel,
    modalQuickAdd: modalQuickAdd,
    handleSizebayInjection: handleSizebayInjection
};
